import { Box } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { type IconButtonProps, type IconType } from "@src/appV2/redesign/system/ui-components";

export function AbsoluteSmallButton(
  props: {
    onClick: () => void;
    position: "right" | "left";
    label?: string;
    iconType: IconType;
    /** Whether to apply the default top spacing. Defaults to true. Set to false when the parent already handles safe-area top padding. */
    includeTopSpacing?: boolean;
  } & Partial<IconButtonProps>
) {
  const { onClick, position, label, includeTopSpacing = true, ...buttonProps } = props;

  return (
    <Box
      position="absolute"
      top={includeTopSpacing ? (theme) => theme.spacing(6) : undefined}
      right={position === "right" ? (theme) => theme.spacing(6) : undefined}
      left={position === "left" ? (theme) => theme.spacing(6) : undefined}
      sx={(theme) => ({ zIndex: theme.zIndex.modal + 1 })}
    >
      <IconButton
        size="small"
        variant="outlined"
        aria-label={label}
        onClick={onClick}
        {...buttonProps}
      />
    </Box>
  );
}
